<template>
  <div class="book">
    <BookCoverDetails :book="book" />

    <BookChapters :book="book" />

    <CourseGroupBox class="container" type="book"/>
  </div>
</template>

<script>
  import BookCoverDetails from '@/components/book/BookCoverDetails'
  import BookChapters from '@/components/book/BookChapters'  
  import { getBook } from '@/api/book.api'
  import CourseGroupBox from '@/components/group/CourseGroupBox'

  export default {
    data: () => ({
      book: {}
    }),

    components: {
      BookCoverDetails,
      BookChapters,
      CourseGroupBox
    },

    mounted () {
      this.fetchBook()
    },

    computed: {
      id () {
        return this.$route.params.id
      }
    },

    methods: {
      async fetchBook () {
        try {
          this.book = await getBook(this.id)
        } catch (err) {
          this.$router.replace('/')
        }
      }
    }
  }
</script>
